import { createSlice } from '@reduxjs/toolkit'

const progressBarSlice = createSlice({
  name: 'progressBar',
  initialState: {
    current: null,
  },
  reducers: {
    setProgressBar: (state, { payload }) => {
      state.current = payload
    },
    clearProgressBar: state => {
      state.current = null
    },
  },
})
const { actions, reducer } = progressBarSlice
export const { setProgressBar, clearProgressBar } = actions
export default reducer
